import { getCurrentCulture } from '@99designs/i18n';

// Must stay in step with languageRules in the create service, which decides the spelling the
// chat assistant itself uses. If the two lists drift, the heading contradicts the conversation.
const BRITISH_SPELLING_LOCALES = ['en-gb', 'en-au', 'en-ca'];

export interface ColorSpelling {
    singular: string;
    plural: string;
    pluralTitleCase: string;
}

export function colorSpelling(): ColorSpelling {
    const isBritish = BRITISH_SPELLING_LOCALES.includes(getCurrentCulture().toLowerCase());

    return isBritish
        ? { singular: 'colour', plural: 'colours', pluralTitleCase: 'Colours' }
        : { singular: 'color', plural: 'colors', pluralTitleCase: 'Colors' };
}
